module.exports = __webpack_public_path__ + "static/media/not-notification-icon.88a240a9.svg";